import React, { Component } from "react";
import { connect } from "react-redux";
import { auth } from "../Authentication/firebase/firebase";
import { withRouter, Link } from "react-router-dom";
import API_Root from "../Constants/API_Root";
import { toggleToast } from "../Actions/ToggleToast";
import "../private-chatbot.css";
import ReactDOM from "react-dom";
import ReactMarkdown from "react-markdown";
import { authFetch } from "../Authentication/authService";

class PrivateChatbot extends Component {
  constructor(props) {
    super(props);
    this.chatMessagesRef = React.createRef();
    this.state = {
      message: "",
      messages: [],
      isLoading: false,
      threadId: null,
      isSidebarOpen: true,
      darkMode: false,
      isLoggedIn: false,
      userEmail: "",
      selectedFiles: [],
      filenames: [],
      pocAccess: false,
      generatedUserId: null,
      session_id: null,
      newSession_id: null,
      sessions: [],
      isOwner: false,
      instanceExists: false,
      isAdmin: false,
      groups: [],
      showTeamMembers: false,
      isModalVisible: false,
      modalPosition: { x: 0, y: 0 },
      ingestionJobStatus: null,
      isAdminModalOpen: false,
      showTeamInput: false,
      newTeamName: "",
      teams: [],
      isInviteModalOpen: false,
      selectedTeam: null,
      organizationEmails: [],
      selectedInvites: [],
      selectedRoles: {},
      teamMembers: {},
      filesForApproval: [],
      isEditTeamModalOpen: false,
      selectedTeamForEdit: null,
      editTeamMembers: [],
      selectedModel: "llama38b",
      ingestionJobId: "",
      firstName: "",
      lastName: "",
      isFeedbackModalVisible: false,
      feedbackMessage: "",
      feedbackTargetMessage: "",
      modalPosition: { x: 0, y: 0 },
      feedbackInputs: {},
      feedbackStatus: {},
      isSmallModalVisible: false,
      selectedSessionId: null,
      isRenaming: false,
      newSessionName: "",
      selectedSwitchTeams: "",
      switchTeams: [],
      teamMembers: [],
      selectedTeamId: null,
      teamStorageUsage: 0,
      lastSynced: "",
      currentTeamName: "",
      responseType: "Text",
      searchQuery: "",
      filteredMessages: [],
      showSearch: false,
      anonymous: false,
      selectedApprovedFiles: [], // To store selected file names
      showInviteInput: false,
      newMemberEmail: "",
      newMemberRole: "user", // default role
    };
  }

  componentDidMount() {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (!isLoggedIn) {
      this.props.history.push("/login");
    }
    this.setState({ isLoggedIn });

    auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState(
          {
            isLoggedIn: true,
            userEmail: user.email,
          },
          () => {
            // Now that userEmail is set, call the functions that depend on it
            this.fetchUserRole(user.email);
            this.fetchProfileInformation(user.email); // use user.email directly
            this.fetchDemoSessions();
            this.fetchTeamMembers();
            this.fetchDemoFiles(); // Moved here, so userEmail is set
            this.fetchTeams();
            this.fetchTeamInfo();
            if (localStorage.getItem("syncing") === "true") {
              this.handleCheckSyncStatus();
            }
          }
        );
      } else {
        this.setState({
          isLoggedIn: false,
          userEmail: null,
        });
      }
    });
    this.fetchOrganizationEmails();
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  openFeedbackModal = (message, event) => {
    console.log("Opening feedback modal with message:", message); // Add debug log
    const rect = event.target.getBoundingClientRect();
    this.setState({
      isFeedbackModalVisible: true,
      feedbackTargetMessage: message, // Ensure message contains `id` and `feedback_status`
      modalPosition: {
        x: rect.left + window.scrollX,
        y: rect.top + window.scrollY - 40,
      },
    });
  };

  fetchTeamStorageUsage = () => {
    const team_id = this.state.selectedTeamId; // Ensure this is set from your user/team info
    if (!team_id) return;
    authFetch(`${API_Root}team/get-team-storage-usage`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ team_id }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (!data.error) {
          this.setState({ teamStorageUsage: data.usedBytes });
        }
      })
      .catch((error) => {
        console.error("Error fetching storage usage:", error);
      });
  };

  closeFeedbackModal = () => {
    this.setState({
      isFeedbackModalVisible: false,
      feedbackMessage: "",
      feedbackTargetMessage: "",
    });
  };

  openSmallModal = (sessionId) => {
    this.setState({
      isSmallModalVisible: true,
      selectedSessionId: sessionId,
    });
  };

  closeSmallModal = () => {
    this.setState({ isSmallModalVisible: false });
  };

  fetchFilesForApproval = () => {
    authFetch(API_Root + "files/get-unapproved-files", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.setState({ filesForApproval: data.files || [] });
      })
      .catch((error) => {
        console.error("Error fetching files for approval:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to fetch files for approval.",
        });
      });
  };

  fetchTeams = () => {
    authFetch(`${API_Root}team/demo-fetch-teams`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: this.state.userEmail }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Update switchTeams with the teams from the backend
        this.setState({ switchTeams: data.teams });
      })
      .catch((error) => {
        console.error("Error fetching teams:", error);
      });
  };

  openEditTeamModal = (teamName) => {
    this.setState(
      { selectedTeamForEdit: teamName, isEditTeamModalOpen: true },
      this.fetchTeamMembersForEdit
    );
  };

  fetchTeamMembersForEdit = () => {
    const { selectedTeamForEdit } = this.state;

    authFetch(API_Root + "team/get-team-members-by-name", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ team_name: selectedTeamForEdit }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.setState({ editTeamMembers: data.members || [] });
      })
      .catch((error) => {
        console.error("Error fetching team members:", error);
      });
  };

  removeTeamMember = (email) => {
    const { selectedTeamForEdit } = this.state;

    authFetch(API_Root + "team/remove-team-member", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ team_name: selectedTeamForEdit, email }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(() => {
        this.setState((prevState) => ({
          editTeamMembers: prevState.editTeamMembers.filter(
            (member) => member.email !== email
          ),
        }));
        this.props.toggleToast({
          show: true,
          type: "success",
          message: `${email} removed from the team.`,
        });
      })
      .catch((error) => {
        console.error("Error removing team member:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to remove team member.",
        });
      });
  };

  closeEditTeamModal = () => {
    this.setState({
      isEditTeamModalOpen: false,
      selectedTeamForEdit: null,
      editTeamMembers: [],
    });
    this.fetchTeamMembers();
  };

  fetchUserRole = (email) => {
    authFetch(API_Root + "team/get-user-role", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.setState({ isAdmin: data.role === "admin" });
      })
      .catch((error) => {
        console.error("Error fetching user role:", error);
      });
  };

  submitFeedback = () => {
    const { feedbackMessage, feedbackTargetMessage, session_id } = this.state;

    if (!feedbackTargetMessage || !session_id) {
      this.props.toggleToast({
        show: true,
        type: "error",
        message: "Invalid feedback submission.",
      });
      return;
    }

    const { id: message_id, feedback_status } = feedbackTargetMessage; // Extract ID and feedback status

    authFetch(`${API_Root}users/demo-submit-feedback`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        session_id,
        message_id,
        feedback_status, // True (Thumbs Up) or False (Thumbs Down)
        feedback_msg: feedbackMessage || "", // Optional comment
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(() => {
        this.props.toggleToast({
          show: true,
          type: "success",
          message: "Feedback submitted successfully.",
        });
        this.setState({
          isFeedbackModalVisible: false,
          feedbackMessage: "",
          feedbackTargetMessage: "",
        });
      })
      .catch((error) => {
        console.error("Error submitting feedback:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to submit feedback. Please try again.",
        });
      });
  };

  fetchTeamMembers = () => {
    const { userEmail } = this.state;

    authFetch(API_Root + "team/get-team-members", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: userEmail }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const { team_id, team_name, members } = data;
        this.setState({
          selectedTeamId: team_id,
          teamMembers: members,
          currentTeamName: team_name,
        });
      })
      .catch((error) => {
        console.error("Error fetching team members:", error);
      });
  };

  fetchOrganizationEmails = () => {
    authFetch(API_Root + "admin/get-organization-users", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ organization_id: 1 }), // Pass organization_id dynamically if needed
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const emails = data.users; // No need to map `user.email` since backend is returning a list of usernames
        this.setState({ organizationEmails: emails });
      })
      .catch((error) => {
        console.error("Error fetching organization emails:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to fetch organization emails.",
        });
      });
  };

  fetchDemoFiles = () => {
    const { userEmail } = this.state;

    authFetch(`${API_Root}team/get-demo-files`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: userEmail }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.setState({ filenames: data.filenames || [] });
      })
      .catch((error) => {
        console.error("Error fetching demo files:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to fetch files from the database.",
        });
      });
  };

  handleDeleteMessage = (messageId) => {
    authFetch(`${API_Root}chat/demo-delete-message`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message_id: messageId }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Remove all messages with this shared id (both prompt and response)
        this.setState((prevState) => ({
          messages: prevState.messages.filter((msg) => msg.id !== messageId),
        }));
        this.props.toggleToast({
          show: true,
          type: "success",
          message: data.message,
        });
      })
      .catch((error) => {
        console.error("Error deleting message:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to delete message",
        });
      });
  };

  removeFileFromApproval = (index) => {
    this.setState(
      (prevState) => ({
        filesForApproval: prevState.filesForApproval.filter(
          (_, i) => i !== index
        ),
      }),
      () => {
        this.props.toggleToast({
          show: true,
          type: "success",
          message: "File removed from the approval list.",
        });
      }
    );
  };

  handleDeleteAllFiles = () => {
    if (
      window.confirm(
        "Are you sure you want to delete all files? This action cannot be undone."
      )
    ) {
      authFetch(`${API_Root}files/demo-delete-files-all`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: this.state.userEmail }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          this.props.toggleToast({
            show: true,
            type: "success",
            message: data.message,
          });
          // Optionally refresh the file list
          this.fetchDemoFiles();

          // Now start the sync since files have been deleted
          authFetch(`${API_Root}files/demo-sync`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: this.state.userEmail }),
          })
            .then((syncResponse) => {
              if (!syncResponse.ok) {
                throw new Error(
                  `HTTP error during sync! Status: ${syncResponse.status}`
                );
              }
              return syncResponse.json();
            })
            .then((syncData) => {
              if (syncData.ingestionJobId) {
                // Store ingestionJobId in localStorage
                localStorage.setItem("ingestionJobId", syncData.ingestionJobId);
                this.props.toggleToast({
                  show: true,
                  type: "info",
                  message:
                    "Sync started successfully. Ingestion job ID stored.",
                });
              } else {
                this.props.toggleToast({
                  show: true,
                  type: "error",
                  message: "Sync started but no ingestion job ID was returned.",
                });
              }
            })
            .catch((syncError) => {
              console.error("Error starting sync:", syncError);
              this.props.toggleToast({
                show: true,
                type: "error",
                message: "Failed to start sync after deletion.",
              });
            });
        })
        .catch((error) => {
          console.error("Error deleting all files:", error);
          this.props.toggleToast({
            show: true,
            type: "error",
            message: "Failed to delete all files",
          });
        });
    }
  };

  approveFile = (fileId) => {
    authFetch(API_Root + "files/approve-file", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: fileId }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(() => {
        this.setState((prevState) => ({
          filesForApproval: prevState.filesForApproval.filter(
            (file) => file.id !== fileId
          ),
        }));
        this.props.toggleToast({
          show: true,
          type: "success",
          message: "File approved successfully!",
        });
      })
      .catch((error) => {
        console.error("Error approving file:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to approve the file.",
        });
      });
  };

  fetchTeamInfo = () => {
    authFetch(`${API_Root}team/demo-get-team-info`, {
      // Create this endpoint on the backend to return { last_synced: ... }
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: this.state.userEmail }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.last_synced) {
          this.setState({ lastSynced: data.last_synced });
        }
      })
      .catch((error) => console.error("Error fetching team info:", error));
  };

  addTeam = () => {
    const { newTeamName } = this.state;

    if (newTeamName.trim() === "") {
      this.props.toggleToast({
        show: true,
        type: "warning",
        message: "Please enter a valid team name.",
      });
      return;
    }

    

    // authFetch(API_Root + "/request-team-creation", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify({
    //     team_name: newTeamName,
    //     email: this.state.userEmail,
    //   }),
    // })
    //   .then((response) => {
    //     if (!response.ok) {
    //       throw new Error(`HTTP error! Status: ${response.status}`);
    //     }
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.setState(
    //       (prevState) => ({
    //         teams: [...prevState.teams, newTeamName],
    //         newTeamName: "",
    //         showTeamInput: false,
    //       }),
    //       () => {
    //         this.props.toggleToast({
    //           show: true,
    //           type: "success",
    //           message: "Team creation request sent successfully!",
    //         });
    //       }
    //     );
    //   })
    //   .catch((error) => {
    //     console.error("Error creating team:", error);
    //     this.props.toggleToast({
    //       show: true,
    //       type: "error",
    //       message: "Failed to add team.",
    //     });
    //   });
  };

  fetchDemoTeams = () => {
    authFetch(`${API_Root}team/demo-fetch-teams`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: this.state.userEmail }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.setState({ teams: data.teams || [] });
      })
      .catch((error) => {
        console.error("Error fetching demo teams:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to fetch teams.",
        });
      });
  };

  openAdminModal = () => {
    this.fetchDemoTeams(); // Fetch the teams when the modal opens
    this.fetchFilesForApproval();
    this.fetchTeamStorageUsage();
    this.setState({ isAdminModalOpen: true });
  };

  handleInviteToTeam = (team) => {
    this.setState({ isInviteModalOpen: true, selectedTeam: team });
    authFetch(API_Root + "team/get-team-members-by-name", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ team_name: team }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.setState({ teamMembers: data.members || [] });
      });
  };

  closeInviteModal = () => {
    this.setState({
      isInviteModalOpen: false,
      selectedTeam: null,
      selectedInvites: [],
      selectedRoles: {},
    });
  };

  handleSelectInvite = (email, isChecked) => {
    this.setState((prevState) => {
      const selectedInvites = isChecked
        ? [...prevState.selectedInvites, email]
        : prevState.selectedInvites.filter((e) => e !== email);
      return { selectedInvites };
    });
  };

  handleRoleChange = (email, role) => {
    this.setState((prevState) => ({
      selectedRoles: { ...prevState.selectedRoles, [email]: role },
    }));
  };

  handleInviteMember = () => {
    const email = this.state.newMemberEmail.trim();
    const role = this.state.newMemberRole;
    const teamName = this.state.selectedTeam;

    if (!email) return;

    const payload = {
      team_name: teamName,
      invites: [
        {
          email,
          role,
        },
      ],
    };

    authFetch(API_Root + "team/invite-team-members", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // Add authorization if needed, e.g.:
        // "Authorization": "Bearer " + token,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to invite member");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Invite successful:", data);

        // Update local state to show the member in UI
        this.setState((prevState) => ({
          teamMembers: [...prevState.teamMembers, { email }],
          selectedRoles: {
            ...prevState.selectedRoles,
            [email]: role,
          },
          showInviteInput: false,
          newMemberEmail: "",
          newMemberRole: "user",
        }));
      })
      .catch((error) => {
        console.error("Error inviting member:", error);
        // Optional: show error to user
      });
  };

  handleSendInvites = () => {
    const { selectedInvites, selectedRoles, selectedTeam } = this.state;

    if (selectedInvites.length === 0) {
      this.props.toggleToast({
        show: true,
        type: "warning",
        message: "Please select at least one user to assign.",
      });
      return;
    }

    const invites = selectedInvites.map((email) => ({
      email,
      role: selectedRoles[email] || "user",
    }));

    authFetch(API_Root + "team/invite-team-members", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        team_name: selectedTeam,
        invites,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.props.toggleToast({
          show: true,
          type: "success",
          message: `${selectedInvites.length} members assigned to ${selectedTeam}!`,
        });
        this.closeInviteModal();
      })
      .catch((error) => {
        console.error("Error inviting team members:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to assign members to the team.",
        });
      });
  };

  closeAdminModal = () => {
    this.setState({ isAdminModalOpen: false });
  };

  toggleSidebar = () => {
    this.setState(
      (prevState) => ({
        isSidebarOpen: !prevState.isSidebarOpen,
        showTeamMembers: prevState.isSidebarOpen
          ? false
          : prevState.showTeamMembers,
      }),
      () => {
        this.forceUpdate();
      }
    );
  };

  handleContextMenu = (event, sessionId) => {
    event.preventDefault();

    const menuWidth = 200; // Adjust based on the expected width of your menu
    const menuHeight = 500; // Adjust based on the expected height of your menu

    let x = event.clientX;
    let y = event.clientY;

    // Adjust for any potential offsets
    const offsetX = 0;
    const offsetY = -50;

    // Check if the menu would overflow the right edge of the viewport
    if (x + menuWidth > window.innerWidth) {
      x = window.innerWidth - menuWidth;
    }

    // Check if the menu would overflow the bottom edge of the viewport
    if (y + menuHeight > window.innerHeight) {
      y = window.innerHeight - menuHeight;
    }

    this.setState({
      isModalVisible: true,
      modalPosition: { x: x + offsetX, y: y + offsetY },
      selectedSessionId: sessionId,
    });
  };

  closeModal = () => {
    this.setState({
      isModalVisible: false,
      modalPosition: { x: 0, y: 0 },
      selectedSessionId: null,
    });
  };

  checkIngestionJobStatus = (email) => {
    fetch(API_Root + "private/get-ingestion-job-status", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("Ingestion Job Status:", data);

        const status = data.ingestionJob?.status;

        if (status === "IN_PROGRESS") {
          this.props.toggleToast({
            show: true,
            type: "info",
            message:
              "The chatbot is preparing a new environment. Please try again at a later time.",
          });
        } else {
          this.setState({ ingestionJobStatus: data });
        }
      })
      .catch((error) => {
        console.error("Error checking ingestion job status:", error);
      });
  };

  checkOwnership = (email) => {
    authFetch(API_Root + "admin/check-ownership", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.setState({
          isOwner: data.isOwner,
          instanceExists: data.instanceExists,
        });
      })
      .catch((error) => {
        console.error("Error checking ownership:", error);
      });
  };

  checkAdminRole = (email) => {
    authFetch(API_Root + "admin/check-admin-role", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.setState({ isAdmin: data.isAdmin });
      })
      .catch((error) => {
        console.error("Error checking admin role:", error);
      });
  };

  createInstance = () => {
    const { userEmail } = this.state;

    this.setState({ isLoading: true });

    fetch(API_Root + "private/create-private-instance", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userEmail }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.setState({ isLoading: false });
        this.props.toggleToast({
          show: true,
          type: "success",
          message: "Private instance created successfully",
        });
        this.checkOwnership(userEmail); // Refresh ownership and instance status
      })
      .catch((error) => {
        console.error("Error creating instance:", error);
        this.setState({ isLoading: false });
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Error creating private instance.",
        });
      });
  };

  fetchProfileInformation = (email) => {
    authFetch(API_Root + "users/get-profile-information", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        ip_address: this.state.ip_address,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.setState(
          {
                    firstName: data.myesra_subscription.first_name || 'None',
                    lastName: data.myesra_subscription.last_name || 'None',
                    pocAccess: data.myesra_subscription.access || false
          },
          () => {
            if (!this.state.pocAccess) {
              this.props.history.push("/");
              return null;
            }
          }
        );
      })
      .catch((error) => {});
  };

  fetchUserGroups = (email) => {
    fetch(API_Root + "private/get-private-chatbot-groups", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("Fetched groups:", data.groups);
        this.setState({ groups: data.groups || [] });
      })
      .catch((error) => {
        console.error("Error fetching user groups:", error);
      });
  };

  handleFileUpload = () => {
    const { selectedFiles, userEmail } = this.state;

    if (selectedFiles.length === 0) {
      this.props.toggleToast({
        show: true,
        type: "warning",
        message: "Please select files for upload.",
      });
      return;
    }

    // Start a timer to simulate progress updates
    this.uploadProgressInterval = setInterval(() => {
      this.setState((prevState) => {
        const updatedFiles = prevState.selectedFiles.map((fileObj) => {
          // If progress is less than 99, increment it randomly by 1 to 5%
          if (fileObj.progress < 99) {
            const increment = Math.floor(Math.random() * 5) + 1;
            return {
              ...fileObj,
              progress: Math.min(fileObj.progress + increment, 99),
            };
          }
          return fileObj;
        });
        return { selectedFiles: updatedFiles };
      });
    }, 500); // update every 500ms

    // Prepare the FormData as before
    const formData = new FormData();
    selectedFiles.forEach((fileObj) => {
      formData.append("files", fileObj.file);
    });
    formData.append("email", userEmail);

    authFetch(`${API_Root}files/demo-upload`, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          throw new Error(data.error);
        }
        // On success, update all files to 100% progress
        this.setState(
          (prevState) => {
            const updatedFiles = prevState.selectedFiles.map((fileObj) => ({
              ...fileObj,
              progress: 100,
            }));
            return { selectedFiles: updatedFiles };
          },
          () => {
            // Clear the progress interval
            clearInterval(this.uploadProgressInterval);
            // Optionally, wait a short moment before clearing the files so user sees 100%
            setTimeout(() => {
              this.setState({ selectedFiles: [] });
              this.props.toggleToast({
                show: true,
                type: "success",
                message: data.message,
              });
              // Refresh the files
              this.fetchDemoFiles();
              this.fetchFilesForApproval();
            }, 500);
          }
        );
      })
      .catch((error) => {
        console.error("Error uploading files:", error);
        clearInterval(this.uploadProgressInterval);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to upload files. Please try again.",
        });
      });
  };

  handleFileChange = (event) => {
    const files = Array.from(event.target.files).map((file) => ({
      file,
      status: "Pending",
      progress: 0, // initial progress
    }));
    this.setState({ selectedFiles: [...this.state.selectedFiles, ...files] });
  };

  updateFileStatus = (status) => {
    this.setState((prevState) => ({
      selectedFiles: prevState.selectedFiles.map((fileObj) => ({
        ...fileObj,
        status,
      })),
    }));
  };

  handleFileDelete = (index) => {
    this.setState((prevState) => {
      const selectedFiles = prevState.selectedFiles.filter(
        (_, i) => i !== index
      );
      return { selectedFiles };
    });
  };

  handleMessageChange = (event) => {
    this.setState({ message: event.target.value });
  };

  handleCheckboxChange = (event, filename) => {
    const { selectedApprovedFiles } = this.state;
    if (event.target.checked) {
      this.setState({
        selectedApprovedFiles: [...selectedApprovedFiles, filename],
      });
    } else {
      this.setState({
        selectedApprovedFiles: selectedApprovedFiles.filter(
          (f) => f !== filename
        ),
      });
    }
  };

getChatResponse = () => {
  const {
    message,
    selectedModel,
    newSession_id,
    userEmail,
    responseType,
    selectedApprovedFiles,
    anonymous,
  } = this.state;

  // ✅ Handle Quick Bench Marking + Approved File case
if (
  responseType === "Quick Bench Marking" &&
  selectedApprovedFiles.length > 0
) {
  this.setState({ isLoading: true });

  // Build query string for multiple files
  const queryString = selectedApprovedFiles
    .map((file) => `file_name=${encodeURIComponent(file)}`)
    .join("&");

  const apiUrl = `${API_Root}chat/analyze-documents?${queryString}`;

  authFetch(apiUrl, {
    method: "GET",
    // ❌ Remove 'Content-Type' when fetching a file
    // headers: { "Content-Type": "application/json" },
  })
    .then((response) => {
      if (!response.ok) throw new Error("Network response was not ok");
      return response.blob(); // ✅ Convert to Blob
    })
    .then((blob) => {
      // Create a temporary URL for the file
      const fileURL = window.URL.createObjectURL(blob);

      // Example: automatically open the file in a new tab
      window.open(fileURL, "_blank");

      const analyzedFilesText =
        selectedApprovedFiles.length === 1
          ? `Analyzed file: ${selectedApprovedFiles[0]}`
          : `Analyzed ${selectedApprovedFiles.length} files:\n${selectedApprovedFiles.join(", ")}`;

      const botMessage = {
        sender: "Bot",
        text: "Benchmark analysis completed successfully. File downloaded/opened.",
        type: "response",
      };

      this.setState((prevState) => ({
        messages: [
          ...prevState.messages,
          {
            sender: "You",
            text: analyzedFilesText,
            type: "sent",
          },
          botMessage,
        ],
        message: "",
        isLoading: false,
      }));
    })
    .catch((error) => {
      console.error("Error calling /chat/analyze-documents:", error);
      this.setState({ isLoading: false });
    });

  return; // ✅ Stop here
}


  // ✅ Default flow (Text / Analysis responses)
  if (!message.trim()) {
    return;
  }

  this.setState({ isLoading: true });

  const payload = {
    prompt: message,
    modelId: selectedModel,
    session_id: newSession_id.id,
    email: userEmail,
    responseType,
    anonymous,
  };

  if (selectedApprovedFiles.length > 0) {
    payload.selectedApprovedFiles = selectedApprovedFiles;
  }

  authFetch(`${API_Root}chat/demo-chat-bedrock`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.error) throw new Error(data.error);

      const botMessage = {
        id: data.message_id,
        sender: "Bot",
        text: data.response,
        citations: data.citations?.map((citation) => ({
          filename: citation.filename,
          content: citation.content.substring(0, 300) + "...",
        })),
        type: "response",
      };

      this.setState((prevState) => ({
        messages: [
          ...prevState.messages,
          { sender: "You", text: message, type: "sent" },
          botMessage,
        ],
        message: "",
        isLoading: false,
      }));
    })
    .catch((error) => {
      console.error("Error interacting with Amazon Bedrock:", error);
      this.setState({ isLoading: false });
    });
};




  // Add this new method to your component
  openFile = (filename) => {
    // Construct the S3 URL
    // Replace 'your-bucket-name' with your actual S3 bucket name and adjust the region/path as needed.
    const fileUrl = `https://almasi-demo-kb.s3.us-east-1.amazonaws.com/${filename}`;
    window.open(fileUrl, "_blank");
  };

  createNewChatSession = () => {
    const sessionName = "New Session"; // Default session name
    const { userEmail } = this.state; // Ensure userEmail is set

    authFetch(`${API_Root}session/create-demo-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ session_name: sessionName, email: userEmail }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const newSession = {
          id: data.session_id,
          chat_name: data.session_name, // Use 'chat_name' to match existing session mapping
        };

        // Update sessions in state
        this.setState(
          (prevState) => ({
            sessions: [...prevState.sessions, newSession],
          }),
          () => {
            this.props.toggleToast({
              show: true,
              type: "success",
              message: `Session "${sessionName}" created successfully!`,
            });
          }
        );
        this.fetchDemoSessions();
      })
      .catch((error) => {
        console.error("Error creating new session:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to create a new session. Please try again.",
        });
      });
  };

  handleRedirect = () => {
    this.props.history.push("/profile");
  };

  exportSession = (sessionId) => {
    const { userEmail } = this.state;

    authFetch(`${API_Root}session/demo-export-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        session_id: sessionId,
        email: userEmail, // Sending the user email
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.blob(); // Get the response as a blob
      })
      .then((blob) => {
        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `session_${sessionId}.csv`; // Set the desired file name
        document.body.appendChild(a);
        a.click(); // Trigger the download
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error exporting session:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to export session. Please try again.",
        });
      });
  };

  fetchDemoSessions = () => {
    const { userEmail } = this.state;
    authFetch(`${API_Root}session/fetch-demo-sessions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: userEmail }),
    })
      .then((response) => {
        console.log("Response status:", response.status); // Debugging log
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("Fetched sessions:", data.sessions); // Debugging log
        this.setState({ sessions: data.sessions || [] });
        this.setState({ newSession_id: data?.sessions?.[0] || [] });
      })
      .catch((error) => {
        console.error("Error fetching demo sessions:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to fetch demo sessions. Please try again.",
        });
      });
  };

  toggleSidebarMenu = (event, sessionId) => {
    event.stopPropagation(); // Prevent bubbling up

    const rect = event.target.getBoundingClientRect();

    this.setState(
      (prevState) => {
        console.log("Toggling menu for session:", sessionId);
        console.log("Previous Menu State:", prevState.isSidebarMenuVisible);

        return {
          isSidebarMenuVisible:
            prevState.selectedSessionId !== sessionId ||
            !prevState.isSidebarMenuVisible,
          menuPosition: {
            x: rect.left + window.scrollX + 10,
            y: rect.top + window.scrollY + 10,
          },
          selectedSessionId: sessionId,
        };
      },
      () => {
        console.log("Updated Menu State:", this.state.isSidebarMenuVisible); // Check if state is updating
      }
    );
  };

  // Close the sidebar menu when clicking outside
  handleClickOutside = (event) => {
    if (
      this.state.isSidebarMenuVisible &&
      this.sidebarMenuRef &&
      !this.sidebarMenuRef.contains(event.target)
    ) {
      this.setState({ isSidebarMenuVisible: false, selectedSessionId: null });
    }
  };

  handleDeleteFile = (filename) => {
    authFetch(`${API_Root}files/delete-demo-file`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ filename }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          throw new Error(data.error);
        }

        this.setState((prevState) => ({
          filenames: prevState.filenames.filter((file) => file !== filename),
        }));
        this.props.toggleToast({
          show: true,
          type: "success",
          message: `File "${filename}" deleted successfully.`,
        });
      })
      .catch((error) => {
        console.error("Error deleting file:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to delete file. Please try again.",
        });
      });
  };

  handleSyncFiles = () => {
    const { userEmail } = this.state;
    authFetch(`${API_Root}files/demo-sync`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: userEmail }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          throw new Error(data.error);
        }

        // Store the ingestionJobId in state and in localStorage.
        this.setState({ ingestionJobId: data.ingestionJobId });
        localStorage.setItem("ingestionJobId", data.ingestionJobId);

        this.props.toggleToast({
          show: true,
          type: "success",
          message: data.message + ` (Job ID: ${data.ingestionJobId})`,
        });
      })
      .catch((error) => {
        console.error("Error syncing files:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to sync files. Please try again.",
        });
      });
  };

  handleCheckSyncStatus = () => {
    const { userEmail, ingestionJobId: stateIngestionJobId } = this.state;
    const localIngestionJobId = localStorage.getItem("ingestionJobId");
    const ingestionJobId = localIngestionJobId || stateIngestionJobId;

    if (!ingestionJobId) {
      this.props.toggleToast({
        show: true,
        type: "warning",
        message: "No ingestion job ID found. Please sync files first.",
      });
      return;
    }
    localStorage.setItem("syncing", "true");
    this.props.toggleToast({
      show: true,
      type: "info",
      message: "Sync is in progress...",
    });

    authFetch(`${API_Root}files/demo-check-sync`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ingestionJobId, email: userEmail }),
    })
      .then((response) => response.json())
      .then((data) => {
        localStorage.setItem("syncing", "false");

        if (data.error) {
          throw new Error(data.error);
        }

        this.props.toggleToast({
          show: true,
          type: "info",
          message: `Ingestion job status: ${data.status}`,
        });
      })
      .catch((error) => {
        localStorage.setItem("syncing", "false");
        console.error("Error checking sync status:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to check sync status. Please try again.",
        });
      });
  };

  fetchUserSessions = (email) => {
    fetch(API_Root + "private/private-chatbot-sessions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.setState({ sessions: data.sessions });
      })
      .catch((error) => {
        console.error("Error fetching user sessions:", error);
      });
  };

  fetchFiles = (email) => {
    fetch(API_Root + "private/get-all-private-files", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.error) {
          throw new Error(data.error);
        }
        this.setState({ filenames: data.filenames });
      })
      .catch((error) => {
        console.error("Error fetching files:", error);
      });
  };

  deleteDemoSession = (sessionId) => {
    authFetch(`${API_Root}session/delete-demo-session`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          // Update state to remove the session from the list
          this.setState((prevState) => ({
            sessions: prevState.sessions.filter(
              (session) => session.id !== sessionId
            ),
          }));

          this.props.toggleToast({
            show: true,
            type: "success",
            message: `Session "${sessionId}" deleted successfully.`,
          });
        } else {
          throw new Error(data.message || "Failed to delete session.");
        }
      })
      .catch((error) => {
        console.error("Error deleting session:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: `${error.message}`,
        });
      });
  };

toggleVoiceInputForMessage = () => {
  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;

  if (!SpeechRecognition) {
    alert("Sorry, your browser does not support speech recognition.");
    return;
  }

  // Stop listening if already active
  if (this.recognition && this.state.isListening) {
    this.recognition.stop();
    this.setState({ isListening: false });
    console.log("🎤 Stopped listening for message input.");
    return;
  }

  // Auto use browser/system language
  const lang = navigator.language || "en-IN";

  this.recognition = new SpeechRecognition();
  this.recognition.lang = lang; // 👈 automatically picks user’s language
  this.recognition.interimResults = true;
  this.recognition.continuous = true;

  let finalTranscript = this.state.message || "";

  this.recognition.onstart = () => {
    this.setState({ isListening: true });
    console.log(`🎤 Listening for message (language: ${lang})`);
  };

  this.recognition.onresult = (event) => {
    let interimTranscript = "";
    for (let i = event.resultIndex; i < event.results.length; ++i) {
      const transcript = event.results[i][0].transcript.trim();
      if (event.results[i].isFinal) {
        finalTranscript += " " + transcript;
      } else {
        interimTranscript += " " + transcript;
      }
    }

    const combined = (finalTranscript + interimTranscript).trim();
    this.setState({ message: combined });
  };

  this.recognition.onerror = (event) => {
    console.error("Speech recognition error:", event.error);
    if (event.error === "not-allowed") {
      alert("Microphone access was denied. Please allow mic permissions.");
    }
    this.setState({ isListening: false });
  };

  this.recognition.onend = () => {
    this.setState({ isListening: false });
    console.log("🎤 Voice recognition ended.");
  };

  this.recognition.start();
};



  selectChatSession = (session_id) => {
    this.setState({ session_id, messages: [] }); // Reset messages when a new session is selected

    authFetch(`${API_Root}session/demo-fetch-session-messages`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ session_id }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.messages) {
          this.setState({ messages: data.messages }, () => {
            this.scrollToBottom();
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching session messages:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to fetch messages for the selected session.",
        });
      });
  };

  truncateSessionName = (name) => {
    const words = name.split(" ");
    if (words.length <= 3) {
      return name;
    }
    return words.slice(0, 3).join(" ") + "...";
  };

  deleteSession = () => {
    const { selectedSessionId } = this.state;

    fetch(API_Root + "private/delete-private-chatbot-session", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ session_id: selectedSessionId }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Refresh the session list
        this.fetchUserSessions(this.state.userEmail);
        this.closeModal();
      })
      .catch((error) => {
        console.error("Error deleting session:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Error deleting session, please try again.",
        });
      });
  };

  handleDeleteAll = () => {
    const { userEmail } = this.state;

    fetch(API_Root + "private/private-chatbot-delete-all", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: userEmail }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.props.toggleToast({
          show: true,
          type: "success",
          message: "All files and vectors deleted successfully",
        });
        this.setState({ filenames: [] });
      })
      .catch((error) => {
        console.error("Error deleting all files:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Error deleting all files, please try again.",
        });
      });
  };

  handleDeleteTeam = (teamName) => {
    authFetch(`${API_Root}team/delete-demo-team`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ team_name: teamName }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.props.toggleToast({
          show: true,
          type: "success",
          message: `Team "${teamName}" deleted successfully!`,
        });
        // Remove the team from the state
        this.setState((prevState) => ({
          teams: prevState.teams.filter((team) => team !== teamName),
        }));
      })
      .catch((error) => {
        console.error("Error deleting team:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: `Failed to delete team "${teamName}". Please try again.`,
        });
      });
  };

  switchTeam = (team_id) => {
    authFetch(`${API_Root}team/demo-switch-team`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        team_id: team_id,
        email: this.state.userEmail, // Assuming userEmail is in state
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.props.toggleToast({
          show: true,
          type: "success",
          message: "Switched team successfully!",
        });
        // Refresh the page after switching teams
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error switching team:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to switch team",
        });
      });
  };

  scrollToBottom = () => {
    const chatDiv = this.chatMessagesRef.current;
    if (chatDiv) {
      chatDiv.scrollTop = chatDiv.scrollHeight;
    }
  };

  renameSession = (sessionId) => {
    const { newSessionName } = this.state;

    if (!newSessionName.trim()) {
      alert("Session name cannot be empty.");
      return;
    }

    authFetch(`${API_Root}session/demo-rename-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        session_id: sessionId,
        new_name: newSessionName,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          throw new Error(data.error);
        }

        this.props.toggleToast({
          show: true,
          type: "success",
          message: "Session renamed successfully!",
        });

        this.setState({
          isRenaming: false,
          newSessionName: "",
          isSmallModalVisible: false, // Close modal after rename
        });

        this.fetchDemoSessions();

        // Optionally refresh sessions list here
      })
      .catch((error) => {
        console.error("Error renaming session:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to rename session. Please try again.",
        });
      });
  };

  handleSearchMessages = () => {
    const { session_id, searchQuery } = this.state;
    if (!searchQuery.trim()) {
      this.props.toggleToast({
        show: true,
        type: "warning",
        message: "Please enter a name or email to search.",
      });
      return;
    }

    authFetch(`${API_Root}session/demo-search-session-messages`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id, searchQuery }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // data.messages is an array of prompt/answer objects
        this.setState({ filteredMessages: data.messages });
      })
      .catch((error) => {
        console.error("Error searching session messages:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to search session messages.",
        });
      });
  };

  handleClearSearch = () => {
    this.setState({ searchQuery: "", filteredMessages: [] });
  };

  deleteOrganization = () => {
    if (
      !window.confirm(
        "Are you sure you want to delete the organization demo teams? This action cannot be undone."
      )
    ) {
      return;
    }
    authFetch(`${API_Root}admin/delete-organization`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: this.state.userEmail }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          this.props.toggleToast({
            show: true,
            type: "error",
            message: data.error,
          });
        } else {
          this.props.toggleToast({
            show: true,
            type: "success",
            message: data.message,
          });
          // Optionally refresh state or perform other actions if needed
        }
      })
      .catch((error) => {
        console.error("Error deleting organization:", error);
        this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to delete organization.",
        });
      });
  };

  render() {
    const {
      message,
      messages,
      filteredMessages,
      isLoading,
      isSidebarOpen,
      selectedFiles,
      sessions,
      isOwner,
      instanceExists,
      isAdmin,
      groups,
      showTeamMembers,
      isModalVisible,
      modalPosition,
    } = this.state;

    const messagesToRender =
      filteredMessages.length > 0 ? filteredMessages : messages;
    return (
      <div>
        <header className="header">
          <div className="header-left">
            <button
              onClick={this.toggleSidebar}
              className="menu-icon-btn"
              aria-label="Expand or shrink sidebar button"
            >
              <svg
                viewBox="0 0 24 24"
                preserveAspectRatio="xMidYMid meet"
                focusable="false"
                className="menu-icon1"
              >
                <g>
                  <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
                </g>
              </svg>
            </button>
            <div className="logo" />
            <span className="logo-text" role="heading">
              <Link to="/" style={{ color: "#3E826D" }}>
                privatESRA
              </Link>
            </span>
          </div>
          <div className="header-right">
            {(this.state.isAdmin ||
              this.state.userEmail === "ildiko@ildiko-almasi.com" ||
              this.state.userEmail === "dilipt@capitalnumbers.com") && (
              <select
                className="model-select"
                defaultValue=""
                onChange={(e) => {
                  const selectedSwitchTeams = e.target.value;
                  if (selectedSwitchTeams !== "") {
                    this.switchTeam(selectedSwitchTeams);
                    // Reset the dropdown so the placeholder "Switch Teams" is always visible.
                    e.target.value = "";
                  }
                }}
                aria-label="Select team"
              >
                <option value="" disabled>
                  Switch Teams
                </option>
                {this.state.switchTeams.map((team) => (
                  <option key={team.id} value={team.id}>
                    {team.team_name}
                  </option>
                ))}
              </select>
            )}

            <select
              className="model-select"
              value={this.state.selectedModel}
              onChange={(e) => this.setState({ selectedModel: e.target.value })}
              aria-label="Select model"
            >
              <option value="llama38b">Llama 3 8B</option>
              <option value="llama370b">Llama 3 70B</option>
              <option value="Claude4_Sonnet">Claude 4</option>
              <option value="Claude3.5_Haiku">Claude3.5_Haiku</option>
            </select>
          </div>
        </header>
        <div className="content">
          <div
            className={`sidebar${isSidebarOpen ? " open" : ""}`}
            id="sidebar"
            role="sidebar"
            aria-label="Sidebar"
            style={{
              overflowY: "auto", // scroll vertically if content overflows
            }}
          >
            <div className="hidden-sidebar">
              <div className="top-sidebar">
                <button
                  className={`new-chat-button ${
                    this.state.isSidebarOpen ? "expanded" : "collapsed"
                  }`}
                  aria-label="New chat button"
                  onClick={this.createNewChatSession}
                >
                  <svg
                    className="sidebar-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="16"></line>
                    <line x1="8" y1="12" x2="16" y2="12"></line>
                  </svg>
                  <span className="button-text">New Chat</span>
                </button>
              </div>

              <div className="middle-sidebar">
                {sessions.map((session) => (
                  <div
                    key={session.id}
                    className="session-container"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <button
                      className="sidebar-item"
                      aria-label="Chat conversation example"
                      onClick={() => this.selectChatSession(session.id)}
                    >
                      <div className="sidebar-item-left">
                        <svg
                          className="sidebar-icon"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-6.616l-2.88 2.592C8.537 20.461 7 19.776 7 18.477V17H5a2 2 0 0 1-2-2V6Zm4 2a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H7Zm8 0a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm-8 3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H7Zm5 0a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2h-5Z" />
                        </svg>
                      </div>
                      <div className="sidebar-item-right">
                        {session.session_name}
                      </div>
                      <button
                        className="dots-icon"
                        aria-label="Session Options"
                        onClick={() => this.openSmallModal(session.id)}
                      ></button>
                    </button>

                    {this.state.isSmallModalVisible &&
                      ReactDOM.createPortal(
                        <div
                          className="small-modal-overlay"
                          onClick={this.closeSmallModal}
                        >
                          <div
                            className="small-modal-box"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <p>Session Options</p>
                            {this.state.isRenaming ? (
                              <>
                                <input
                                  type="text"
                                  placeholder="Enter new session name"
                                  value={this.state.newSessionName}
                                  onChange={(e) =>
                                    this.setState({
                                      newSessionName: e.target.value,
                                    })
                                  }
                                />
                                <button
                                  onClick={() =>
                                    this.renameSession(
                                      this.state.selectedSessionId
                                    )
                                  }
                                >
                                  Confirm Rename
                                </button>
                                <button
                                  onClick={() =>
                                    this.setState({
                                      isRenaming: false,
                                      newSessionName: "",
                                    })
                                  }
                                >
                                  Cancel
                                </button>
                              </>
                            ) : (
                              <button
                                onClick={() =>
                                  this.setState({ isRenaming: true })
                                }
                              >
                                Rename
                              </button>
                            )}

                            <button
                              onClick={() => {
                                if (this.state.selectedSessionId) {
                                  this.deleteDemoSession(
                                    this.state.selectedSessionId
                                  );
                                  this.closeSmallModal();
                                }
                              }}
                            >
                              Delete
                            </button>

                            <button
                              onClick={() => {
                                if (this.state.selectedSessionId) {
                                  this.exportSession(
                                    this.state.selectedSessionId
                                  );
                                  this.closeSmallModal();
                                }
                              }}
                            >
                              Export
                            </button>

                            <button onClick={this.closeSmallModal}>
                              Close
                            </button>
                          </div>
                        </div>,
                        document.body
                      )}
                  </div>
                ))}
              </div>

              {isModalVisible && (
                <div
                  className="context-menu"
                  style={{
                    position: "absolute",
                    top: modalPosition.y,
                    left: modalPosition.x,
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    padding: "10px",
                    zIndex: 1000,
                  }}
                >
                  <button
                    className="delete-session-btn"
                    onClick={this.deleteSession}
                  >
                    Delete
                  </button>
                </div>
              )}
              <div className="bottom-sidebar">
                {this.state.isSidebarOpen && (
                  <div className="user-email-container">
                    <div className="user-email">
                      <strong>
                        {this.state.firstName && this.state.lastName
                          ? `${this.state.firstName} ${this.state.lastName}`
                          : "Loading..."}
                      </strong>
                    </div>
                  </div>
                )}
                <button className="sidebar-item" aria-label="myESRA">
                  <div className="sidebar-item-left">
                    <svg
                      className="sidebar-icon"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      width="64px"
                      height="64px"
                      viewBox="0 0 92 92"
                    >
                      <path
                        id="XMLID_223_"
                        d="M82,32.3V72c0,2.2-1.8,4-4,4H19.1c-2.2,0-4-1.8-4-4s1.8-4,4-4H74V36H23.7l5.5,5.6c1.6,1.6,1.6,4.2,0,5.8 c-0.8,0.8-1.8,1.2-2.8,1.2c-1,0-2-0.4-2.8-1.2L11.2,35.1c-0.8-0.8-1.2-1.8-1.2-2.8c0-1.1,0.4-2.1,1.2-2.8l12.4-12.3 c1.6-1.6,4.1-1.6,5.7,0s1.5,4,0,5.6L23.7,28H78C80.2,28,82,30.1,82,32.3z"
                      ></path>
                    </svg>
                  </div>
                  <div className="sidebar-item-right">
                    <Link
                      to="/chat"
                      style={{ color: "#979797", textDecoration: "none" }}
                    >
                      myESRA
                    </Link>
                  </div>
                </button>
                {(this.state.isAdmin ||
                  this.state.userEmail === "ildiko@ildiko-almasi.com" ||
                  this.state.userEmail === "dilipt@capitalnumbers.com") && (
                  <button
                    className="sidebar-item"
                    aria-label="Admin button"
                    onClick={this.openAdminModal}
                  >
                    <div className="sidebar-item-left">
                      <svg
                        className="sidebar-icon"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        viewBox="0 0 640 512"
                      >
                        <path d="M0 24C0 10.7 10.7 0 24 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM0 488c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM83.2 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 320c0-35.3 28.7-64 64-64h96c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H493.6zM391.2 290.4c32.1 7.4 58.1 30.9 68.9 61.6c3.5 10 5.5 20.8 5.5 32c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c10.5-29.7 35.3-52.8 66.1-60.9c7.8-2.1 16-3.1 24.5-3.1h96c7.4 0 14.7 .8 21.6 2.4zm44-130.4a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z" />
                      </svg>
                    </div>
                    <div className="sidebar-item-right">Admin</div>
                  </button>
                )}
                {this.state.isAdminModalOpen &&
                  ReactDOM.createPortal(
                    <div className="modal-box">
                      <div className="modal-content">
                        <h2>Admin Panel</h2>

                        {/* Create Team Section */}
                        <button
                          onClick={() => this.setState({ showTeamInput: true })}
                        >
                          Create Team
                        </button>
                        {this.state.showTeamInput && (
                          <div>
                            <input
                              type="text"
                              placeholder="Enter team name"
                              value={this.state.newTeamName}
                              onChange={(e) =>
                                this.setState({ newTeamName: e.target.value })
                              }
                            />
                            <br />
                            <button onClick={this.addTeam}>Request Team</button>
                          </div>
                        )}

                        {this.state.teams.length > 0 ? (
                          <div>
                            <h3>Teams</h3>
                            <ul>
                              {this.state.teams.map((team, index) => (
                                <li
                                  key={index}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <span>{team.team_name}</span>
                                  <div style={{ display: "flex", gap: "10px" }}>
                                    <button
                                      style={{
                                        padding: "5px 10px",
                                        backgroundColor: "#3e826d",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        this.handleInviteToTeam(team.team_name)
                                      }
                                    >
                                      Invite
                                    </button>
                                    <button
                                      style={{
                                        padding: "5px 10px",
                                        backgroundColor: "#f0ad4e",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        this.openEditTeamModal(team.team_name)
                                      }
                                    >
                                      Edit
                                    </button>
                                    <button
                                      style={{
                                        padding: "5px 10px",
                                        backgroundColor: "#dc3545",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        this.handleDeleteTeam(team.team_name)
                                      }
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ) : (
                          <p>No teams found.</p>
                        )}

                        {this.state.isEditTeamModalOpen &&
                          ReactDOM.createPortal(
                            <div className="modal-box">
                              <div className="modal-content">
                                <h2>
                                  Edit Team: {this.state.selectedTeamForEdit}
                                </h2>
                                {this.state.editTeamMembers.length > 0 ? (
                                  <ul>
                                    {this.state.editTeamMembers.map(
                                      (member, index) => (
                                        <li
                                          key={index}
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <span>
                                            {member.email} - {member.role}
                                          </span>
                                          <button
                                            style={{
                                              padding: "5px 10px",
                                              backgroundColor: "#dc3545",
                                              color: "white",
                                              border: "none",
                                              borderRadius: "4px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              this.removeTeamMember(
                                                member.email
                                              )
                                            }
                                          >
                                            Remove
                                          </button>
                                        </li>
                                      )
                                    )}
                                  </ul>
                                ) : (
                                  <p>No team members found.</p>
                                )}
                                <button
                                  style={{
                                    marginTop: "10px",
                                    padding: "10px 20px",
                                    backgroundColor: "gray",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                  }}
                                  onClick={this.closeEditTeamModal}
                                >
                                  Close
                                </button>
                              </div>
                            </div>,
                            document.body
                          )}
                        {/* Invite Members Modal */}
                        {this.state.isInviteModalOpen &&
                          ReactDOM.createPortal(
                            <div className="modal-box">
                              <div className="modal-content">
                                <h2>
                                  Invite Members to {this.state.selectedTeam}
                                </h2>
                                <ul>
                                  {this.state.teamMembers.map(
                                    (email, index) => (
                                      <li key={index}>
                                        <span>{email.email}</span>
                                        <select
                                          onChange={(e) =>
                                            this.handleRoleChange(
                                              email.email,
                                              e.target.value
                                            )
                                          }
                                          value={
                                            this.state.selectedRoles[
                                              email.email
                                            ] || "user"
                                          }
                                        >
                                          <option value="user">User</option>
                                          <option value="admin">Admin</option>
                                        </select>
                                        <input
                                          type="checkbox"
                                          onChange={(e) =>
                                            this.handleSelectInvite(
                                              email.email,
                                              e.target.checked
                                            )
                                          }
                                          checked={this.state.selectedInvites.includes(
                                            email.email
                                          )}
                                        />
                                      </li>
                                    )
                                  )}
                                </ul>

                                <button
                                  style={{
                                    marginTop: "10px",
                                    padding: "10px 20px",
                                    backgroundColor: "#3e826d",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                  }}
                                  onClick={this.handleSendInvites}
                                >
                                  Assign Members
                                </button>
                                <button
                                  style={{
                                    marginTop: "10px",
                                    marginLeft: "10px",
                                    padding: "10px 20px",
                                    backgroundColor: "gray",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                  }}
                                  onClick={this.closeInviteModal}
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>,
                            document.body
                          )}
                        <div className="files-for-approval">
                          <h3>Files Pending Approval</h3>
                          <ul>
                            {this.state.filesForApproval.map((file, index) => (
                              <li
                                key={file.id}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  marginBottom: "10px",
                                }}
                              >
                                <div>
                                  <span
                                    className="file-name"
                                    style={{ marginRight: "10px" }}
                                  >
                                    {file.filename}
                                  </span>
                                </div>
                                <div>
                                  <button
                                    style={{
                                      padding: "5px 10px",
                                      backgroundColor: "#3e826d",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => this.approveFile(file.id)}
                                  >
                                    Approve
                                  </button>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div>
                          <h3>Sync Data</h3>
                          <div>
                            Last Synced:{" "}
                            {this.state.lastSynced
                              ? new Date(this.state.lastSynced).toLocaleString()
                              : "N/A"}
                          </div>
                          <button
                            style={{
                              marginTop: "10px",
                              padding: "10px 20px",
                              backgroundColor: "#3e826d",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                            }}
                            onClick={this.handleSyncFiles}
                          >
                            Sync Uploaded Files
                          </button>
                          <button
                            style={{
                              marginTop: "10px",
                              marginLeft: "10px",
                              padding: "10px 20px",
                              backgroundColor: "#007bff",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                            }}
                            onClick={this.handleCheckSyncStatus}
                          >
                            Check Sync Status
                          </button>
                        </div>
                        <div>
                          <h3>Files</h3>
                          <button
                            style={{
                              marginTop: "10px",
                              padding: "10px 20px",
                              backgroundColor: "#6c757d",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                            }}
                            onClick={this.fetchDemoFiles}
                          >
                            Refresh Files
                          </button>
                          <button
                            style={{
                              marginTop: "10px",
                              marginLeft: "10px",
                              padding: "10px 20px",
                              backgroundColor: "#dc3545", // A red color for delete action
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                            }}
                            onClick={this.handleDeleteAllFiles}
                          >
                            Delete All Files
                          </button>
                          {this.state.filenames.length > 0 && (
                            <ul style={{ marginTop: "10px" }}>
                              {this.state.filenames.map((filename, index) => (
                                <li
                                  key={index}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <span>{filename}</span>
                                  <button
                                    style={{
                                      padding: "5px 10px",
                                      backgroundColor: "#dc3545",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      this.handleDeleteFile(filename)
                                    }
                                  >
                                    Delete
                                  </button>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                        <div
                          className="storage-usage"
                          style={{ marginTop: "20px" }}
                        >
                          {/* Convert bytes to GB */}
                          <p>
                            {(
                              this.state.teamStorageUsage /
                              (1024 * 1024 * 1024)
                            ).toFixed(2)}{" "}
                            GB / 5 GB
                          </p>
                          <div
                            className="progress-bar"
                            style={{
                              border: "1px solid #ccc",
                              height: "20px",
                              width: "100%",
                              borderRadius: "5px",
                              overflow: "hidden",
                            }}
                          >
                            <div
                              className="progress-fill"
                              style={{
                                width: `${Math.min(
                                  (this.state.teamStorageUsage /
                                    (5 * 1024 * 1024 * 1024)) *
                                    100,
                                  100
                                )}%`,
                                backgroundColor: "#3E826D",
                                height: "100%",
                              }}
                            ></div>
                          </div>
                        </div>

                        {(this.state.userEmail === "himanshus@capitalnumbers.com" || this.state.userEmail === "ashishv@capitalnumbers.net" ||
                          this.state.userEmail ===
                            "ildiko@ildiko-almasi.com") && (
                          <button
                            onClick={this.deleteOrganization}
                            style={{
                              marginTop: "10px",
                              padding: "10px 20px",
                              backgroundColor: "#dc3545",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                            }}
                          >
                            Delete Organization
                          </button>
                        )}

                        <button onClick={this.closeAdminModal}>Close</button>
                      </div>
                    </div>,
                    document.body
                  )}

                {this.state.isInviteModalOpen &&
                  ReactDOM.createPortal(
                    <div className="modal-box">
                      <div className="modal-content">
                        <h2>Invite Members to {this.state.selectedTeam}</h2>
                        <ul>
                          {this.state.teamMembers.map((email, index) => (
                            <li
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <span>{email.email}</span>
                              <select
                                style={{
                                  marginLeft: "10px",
                                  padding: "5px",
                                  borderRadius: "4px",
                                }}
                                onChange={(e) =>
                                  this.handleRoleChange(
                                    email.email,
                                    e.target.value
                                  )
                                }
                                value={
                                  this.state.selectedRoles[email] || "user"
                                }
                              >
                                <option value="user">User</option>
                                <option value="admin">Admin</option>
                              </select>
                              <input
                                type="checkbox"
                                style={{ marginLeft: "10px" }}
                                onChange={(e) =>
                                  this.handleSelectInvite(
                                    email.email,
                                    e.target.checked
                                  )
                                }
                                checked={this.state.selectedInvites.includes(
                                  email.email
                                )}
                              />
                            </li>
                          ))}
                        </ul>
                        <button
                          style={{
                            marginTop: "10px",
                            padding: "10px 20px",
                            backgroundColor: "#3e826d",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                          onClick={this.handleSendInvites}
                        >
                          Assign Members
                        </button>
                        {this.state.showInviteInput ? (
                          <div
                            style={{
                              marginTop: "10px",
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <input
                              type="email"
                              placeholder="Enter email"
                              value={this.state.newMemberEmail}
                              onChange={(e) =>
                                this.setState({
                                  newMemberEmail: e.target.value,
                                })
                              }
                              style={{
                                padding: "8px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                                flex: "1",
                              }}
                            />
                            <select
                              value={this.state.newMemberRole}
                              onChange={(e) =>
                                this.setState({ newMemberRole: e.target.value })
                              }
                              style={{
                                padding: "8px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                              }}
                            >
                              <option value="user">User</option>
                              <option value="admin">Admin</option>
                            </select>
                            <button
                              style={{
                                padding: "8px 16px",
                                backgroundColor: "#3e826d",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              onClick={this.handleInviteMember}
                            >
                              Invite
                            </button>
                            <button
                              style={{
                                padding: "8px 16px",
                                backgroundColor: "gray",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                this.setState({
                                  showInviteInput: false,
                                  newMemberEmail: "",
                                  newMemberRole: "user",
                                })
                              }
                            >
                              Cancel
                            </button>
                          </div>
                        ) : (
                          <button
                            style={{
                              marginTop: "10px",
                              padding: "8px 16px",
                              backgroundColor: "#007bff",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              this.setState({ showInviteInput: true })
                            }
                          >
                            Add Member
                          </button>
                        )}

                        <button
                          style={{
                            marginTop: "10px",
                            marginLeft: "10px",
                            padding: "10px 20px",
                            backgroundColor: "gray",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                          onClick={this.closeInviteModal}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>,
                    document.body
                  )}

                <div
                  className={`button-container ${
                    showTeamMembers ? "expanded" : ""
                  }`}
                >
                  <button
                    className="sidebar-item"
                    aria-label="Show Team Members"
                    onClick={() =>
                      this.setState((prevState) => ({
                        showTeamMembers: !prevState.showTeamMembers,
                      }))
                    }
                  >
                    <div className="sidebar-item-left">
                      <svg
                        className="sidebar-icon"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        viewBox="0 0 640 512"
                      >
                        <path d="M0 24C0 10.7 10.7 0 24 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM0 488c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM83.2 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 320c0-35.3 28.7-64 64-64h96c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H493.6zM391.2 290.4c32.1 7.4 58.1 30.9 68.9 61.6c3.5 10 5.5 20.8 5.5 32c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c10.5-29.7 35.3-52.8 66.1-60.9c7.8-2.1 16-3.1 24.5-3.1h96c7.4 0 14.7 .8 21.6 2.4zm44-130.4a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z" />
                      </svg>
                    </div>
                    <div className="sidebar-item-right">Team</div>
                  </button>

                  {showTeamMembers && (
                    <div className="container mt-3">
                      {this.state.teamMembers.length > 0 ? (
                        <>
                          <h5 className="mb-3">
                            <strong>
                              {this.state.currentTeamName || "Team Name"}
                            </strong>
                          </h5>

                          {/* Scrollable table wrapper */}
                          <div
                            className="table-responsive"
                            style={{ maxHeight: "200px", overflowY: "auto" }}
                          >
                            <table className="table table-striped table-bordered align-middle mb-0">
                              <thead className="table-light sticky-top">
                                <tr>
                                  <th scope="col" style={{ width: "70%" }}>
                                    Email
                                  </th>
                                  <th scope="col" style={{ width: "30%" }}>
                                    Role
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.teamMembers.map((member, index) => (
                                  <tr key={index}>
                                    <td className="text-break">
                                      {member.email}
                                    </td>
                                    <td>{member.role}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </>
                      ) : (
                        <p>No team members found.</p>
                      )}
                    </div>
                  )}
                </div>

                {isOwner && !instanceExists && (
                  <button
                    className="sidebar-item"
                    aria-label="Create Instance"
                    onClick={this.createInstance}
                  >
                    <div className="sidebar-item-left">
                      <svg
                        className="sidebar-icon"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-6.616l-2.88 2.592C8.537 20.461 7 19.776 7 18.477V17H5a2 2 0 0 1-2-2V6Zm4 2a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H7Zm8 0a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm-8 3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H7Zm5 0a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2h-5Z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="sidebar-item-right">Create Instance</div>
                  </button>
                )}

                <button
                  className="sidebar-item"
                  aria-label="File Upload"
                  onClick={() => this.fileInputRef.click()}
                >
                  <div className="sidebar-item-left">
                    <svg
                      className="sidebar-icon"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      viewBox="0 96 960 960"
                    >
                      <path d="M480 776q-17 0-28.5-11.5T440 736V564l-69 69q-12 12-28 12t-28-12q-11-11-11.5-27.5T315 578l161-161q6-6 13.5-9.5T504 404q8 0 15.5 3.5T533 417l160 161q12 12 11.5 28T693 634q-11 12-28 12t-28-12l-69-69v172q0 17-11.5 28.5T480 776ZM240 936q-33 0-56.5-23.5T160 856V696q0-17 11.5-28.5T200 656q17 0 28.5 11.5T240 696v160h480V696q0-17 11.5-28.5T760 656q17 0 28.5 11.5T800 696v160q0 33-23.5 56.5T720 936H240Z" />
                    </svg>
                  </div>
                  <div className="sidebar-item-right">Upload Files</div>
                  <input
                    type="file"
                    multiple
                    style={{ display: "none" }}
                    ref={(ref) => (this.fileInputRef = ref)}
                    onChange={this.handleFileChange}
                  />
                </button>

                <button
                  className="sidebar-item"
                  aria-label="Profile button"
                  onClick={this.handleRedirect}
                >
                  <div className="sidebar-item-left">
                    <svg
                      className="sidebar-icon"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4Zm10 5a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm0 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm0 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm-8-5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm1.942 4a3 3 0 0 0-2.847 2.051l-.044.133-.004.012c-.042.126-.055.167-.042.195.006.013.02.023.038.039.032.025.08.064.146.155A1 1 0 0 0 6 17h6a1 1 0 0 0 .811-.415.713.713 0 0 1 .146-.155c.019-.016.031-.026.038-.04.014-.027 0-.068-.042-.194l-.004-.012-.044-.133A3 3 0 0 0 10.059 14H7.942Z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="sidebar-item-right">Profile</div>
                </button>
              </div>
            </div>
          </div>

          <main id="main-content" role="main" aria-label="Main content">
            <div className="chatbox">
              {this.state.session_id && (
                <div className="demo-search-container">
                  <button
                    onClick={() =>
                      this.setState((prevState) => ({
                        showSearch: !prevState.showSearch,
                        // Optionally, clear search fields when hiding:
                        searchQuery: prevState.showSearch
                          ? ""
                          : prevState.searchQuery,
                        filteredMessages: prevState.showSearch
                          ? []
                          : prevState.filteredMessages,
                      }))
                    }
                  >
                    Filter
                  </button>
                  {this.state.showSearch && (
                    <>
                      <input
                        type="text"
                        placeholder="Search by email, first name, or last name..."
                        value={this.state.searchQuery}
                        onChange={(e) =>
                          this.setState({ searchQuery: e.target.value })
                        }
                        style={{ marginRight: "8px" }}
                      />
                      <button onClick={this.handleSearchMessages}>
                        Search
                      </button>
                      <button
                        onClick={this.handleClearSearch}
                        style={{ marginLeft: "5px" }}
                      >
                        Clear
                      </button>
                    </>
                  )}
                </div>
              )}
              <div className="chat-messages" ref={this.chatMessagesRef}>
                {messagesToRender.length === 0 ? (
                  <div className="welcome-message">
                    <div className="welcome-logo" />
                    <span role="heading">
                      <h1>Welcome to privatESRA</h1>
                    </span>
                    <div className="sample-prompts-container">
                      <ol>
                        <li>Upload files to your private knowledge base</li>
                        <li>Resolve errors, if any, to complete upload</li>
                        <li>
                          Ask the privatESRA questions about the knowledge base
                        </li>
                        <li>Delete files & conversation history</li>
                      </ol>
                    </div>
                  </div>
                ) : (
                  messagesToRender.map((msg, index) => (
                    <div
                      key={index}
                      className={`demo-message-container-${msg.type}`}
                    >
                      <div className={`demo-message-icon-${msg.type}`}>
                        <div className={`demo-profile-user-icon-${msg.type}`} />
                      </div>
                      <div className={`message-${msg.type}`}>
                        {msg.sender !== "Bot" && (
                          <span className="user-name">
                            {msg.anonymous
                              ? "Anonymous User:"
                              : `${msg.sender}:`}
                          </span>
                        )}
                        <div className="message-text">
                          {msg.text.split("\n").map((line, idx) => (
                            <React.Fragment key={idx}>
                              <ReactMarkdown>{line}</ReactMarkdown>
                            </React.Fragment>
                          ))}
                        </div>
                        {msg.citations && msg.citations.length > 0 && (
                          <div className="citation-container">
                            {msg.citations.map((citation, idx) => (
                              <div key={idx} className="citation-box">
                                Source
                                <span className="tooltip">
                                  <strong>{citation.filename}</strong>
                                  <br />
                                  {citation.content}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                        {(msg.sender === "Privatesra Bot" ||
                          msg.sender === "Bot") && (
                          <div
                            className="feedback-buttons"
                            style={{
                              display: "flex",
                              gap: "10px",
                              marginTop: "10px",
                            }}
                          >
                            <button
                              className="private-thumbs-up"
                              onClick={(e) =>
                                this.openFeedbackModal(
                                  { ...msg, feedback_status: true },
                                  e
                                )
                              }
                              aria-label="Thumbs Up"
                            ></button>
                            <button
                              className="private-thumbs-down"
                              onClick={(e) =>
                                this.openFeedbackModal(
                                  { ...msg, feedback_status: false },
                                  e
                                )
                              }
                              aria-label="Thumbs Down"
                            ></button>
                          </div>
                        )}

                        {msg.model_id && (
                          <small className="model-id">
                            Model: {msg.model_id}
                          </small>
                        )}
                        {msg.response_type &&
                          (msg.sender === "Privatesra Bot" ||
                            msg.sender === "Bot") && (
                            <small className="response-type-text">
                              Response Type: {msg.response_type}
                            </small>
                          )}
                        {msg.sender === "Bot" && this.state.isAdmin && (
                          <button
                            onClick={() => this.handleDeleteMessage(msg.id)}
                            style={{
                              marginTop: "12px",
                              backgroundColor: "#333",
                              color: "white",
                              border: "none",
                              padding: "6px",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontSize: "11px",
                            }}
                          >
                            Delete
                          </button>
                        )}
                      </div>
                    </div>
                  ))
                )}
              </div>

<div
  className="message-input-container"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "10px",
    background: "#f8f9fa",
    borderRadius: "25px",
    padding: "8px 12px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
  }}
>
  {/* Anonymity Selector */}
  <select
    value={this.state.anonymous ? "anonymous" : "show"}
    onChange={(e) =>
      this.setState({ anonymous: e.target.value === "anonymous" })
    }
    aria-label="Select anonymity"
    disabled={this.state.responseType === "Quick Bench Marking" ? true : false}
    style={{
      padding: "6px 10px",
      borderRadius: "20px",
      border: "1px solid #ccc",
      background: "#fff",
      fontSize: "14px",
      cursor: "pointer",
    }}
  >
    <option value="show">Show Name</option>
    <option value="anonymous">Anonymous</option>
  </select>

  {/* Message Input + Voice Button */}
  <div
    className="message-input-wrapper"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      flex: 1,
      background: "#fff",
      borderRadius: "20px",
      border: "1px solid #ddd",
      padding: "5px 10px",
      opacity:
        this.state.responseType === "Quick Bench Marking" ? 0.6 : 1,
      pointerEvents:
        this.state.responseType === "Quick Bench Marking" ? "none" : "auto",
    }}
  >
    <input
      id="message-input"
      type="text"
      aria-label="Input bar. Type your prompt here"
      value={this.state.message}
      onChange={(e) => this.setState({ message: e.target.value })}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          this.getChatResponse();
        }
      }}
      placeholder="Type a message..."
      disabled={this.state.responseType === "Quick Bench Marking"}
      style={{
        flex: 1,
        border: "none",
        outline: "none",
        fontSize: "15px",
        background: "transparent",
      }}
    />

    {/* 🎤 Voice Input Button */}
    <button
      onClick={this.toggleVoiceInputForMessage}
      disabled={this.state.responseType === "Quick Bench Marking"}
      style={{
        background: this.state.isListening ? "#ff4d4d" : "#3E826D",
        color: "#fff",
        border: "none",
        borderRadius: "50%",
        width: "36px",
        height: "36px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor:
          this.state.responseType === "Quick Bench Marking"
            ? "not-allowed"
            : "pointer",
        opacity:
          this.state.responseType === "Quick Bench Marking" ? 0.6 : 1,
        transition: "0.3s",
        boxShadow: this.state.isListening
          ? "0 0 8px rgba(255,0,0,0.6)"
          : "0 2px 5px rgba(0,0,0,0.2)",
      }}
      title={
        this.state.isListening
          ? "Listening... Click to stop"
          : "Click to speak"
      }
    >
      🎤
    </button>
  </div>

  {/* Response Type Selector */}
  <select
    value={this.state.responseType}
    onChange={(e) => this.setState({ responseType: e.target.value })}
    aria-label="Select response type"
    style={{
      padding: "6px 8px",
      borderRadius: "20px",
      border: "1px solid #ccc",
      background: "#fff",
      fontSize: "14px",
      cursor: "pointer",
    }}
  >
    <option value="Text">Text</option>
    <option value="Analysis">Analysis</option>
    <option value="Quick Bench Marking">Quick Bench Marking</option>
  </select>

  {/* Send Button */}
  <button
    id="send-btn"
    aria-label="Send prompt/question button"
    onClick={this.getChatResponse}
    disabled={this.state.isLoading}
    style={{
      background: this.state.isLoading ? "#ccc" : "#3E826D",
      color: "#fff",
      border: "none",
      borderRadius: "50%",
      width: "40px",
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: this.state.isLoading ? "not-allowed" : "pointer",
      transition: "0.3s",
      boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    }}
  >
    {this.state.isLoading ? (
      <div
        className="loader"
        style={{
          border: "3px solid #f3f3f3",
          borderTop: "3px solid #3E826D",
          borderRadius: "50%",
          width: "18px",
          height: "18px",
          animation: "spin 1s linear infinite",
        }}
      ></div>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M5 12h13M12 5l7 7-7 7" />
      </svg>
    )}
  </button>
</div>


<style>
  {`
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `}
</style>

            </div>
            <div className="right-section">
              <div className="right-table">
                {selectedFiles.length > 0 && (
                  <div className="file-bubbles">
                    {selectedFiles.map((fileObj, index) => (
                      <div key={index} className="file-bubble">
                        <div className="file-info">
                          <span className="file-name">{fileObj.file.name}</span>
                          <span className="file-status">{fileObj.status}</span>
                          <div
                            className="upload-progress"
                            style={{
                              height: "2px",
                              width: `${fileObj.progress}%`,
                              backgroundColor: "#3E826D",
                              marginTop: "5px",
                              transition: "width 0.5s ease",
                            }}
                          ></div>
                        </div>

                        <button
                          className="delete-btn"
                          onClick={() => this.handleFileDelete(index)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                          </svg>
                        </button>
                      </div>
                    ))}
                    <button
                      className="upload-btn"
                      onClick={this.handleFileUpload}
                      disabled={isLoading}
                    >
                      {isLoading ? "Uploading..." : "Upload"}
                    </button>
                  </div>
                )}
              </div>

              <div className="file-list">
                <div className="file-nav">
                  <div>
                    Last Synced:{" "}
                    {this.state.lastSynced
                      ? new Date(this.state.lastSynced).toLocaleString()
                      : "N/A"}
                  </div>
                  <div
                    onClick={() => {
                      this.fetchDemoFiles();
                      this.fetchFilesForApproval();
                      this.fetchTeamInfo();
                    }}
                    style={{
                      cursor: "pointer",
                    }}
                    title="Refresh Files"
                  >
                    <svg
                      width="20px"
                      height="20px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M21 12C21 16.9706 16.9706 21 12 21C9.69494 21 7.59227 20.1334 6 18.7083L3 16M3 12C3 7.02944 7.02944 3 12 3C14.3051 3 16.4077 3.86656 18 5.29168L21 8M3 21V16M3 16H8M21 3V8M21 8H16"
                          stroke="#000000"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </div>
                <div className="approved-files">
                  <h1>Approved Files</h1>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {this.state.filenames.map((filename, index) => (
                      <li
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          padding: "6px 8px",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          marginBottom: "6px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          background: "#fff",
                        }}
                      >
                        <input
                          type="checkbox"
                          style={{ flex: "0" }}
                          onChange={(e) =>
                            this.handleCheckboxChange(e, filename)
                          }
                          checked={this.state.selectedApprovedFiles.includes(
                            filename
                          )}
                        />
                        <span
                          onClick={() => this.openFile(filename)}
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            flexGrow: 1,
                          }}
                          title={filename}
                        >
                          {filename}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="unapproved-files">
                  <h1>Unapproved Files</h1>
                  <ul>
                    {this.state.filesForApproval.map((file) => (
                      <li key={file.id}>{file.filename}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapActionsToProps = { toggleToast };

export default withRouter(
  connect(mapStateToProps, mapActionsToProps)(PrivateChatbot)
);
